import { render, staticRenderFns } from "./r-bottom-sheet.vue?vue&type=template&id=650d8148&scoped=true"
import script from "./r-bottom-sheet.vue?vue&type=script&lang=js"
export * from "./r-bottom-sheet.vue?vue&type=script&lang=js"
import style0 from "./r-bottom-sheet.vue?vue&type=style&index=0&id=650d8148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d8148",
  null
  
)

export default component.exports